import React, { useState } from "react";
import Header from "../../component/Header";
import Background from "../../assets/Images/homepage.png";
import SearchBox from "../../component/home/SearchBox";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "sonner";
import { useEffect } from "react";
// ------------images collection---------------

const Hero = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [jobs, setJobs] = useState([]);
  const loggedInUser = useSelector((state) => state.user);
  const handleCv = () => {
    if (loggedInUser?.currentUser === null) {
      toast.error("Kindly login to continue");
      navigate("/signin");
      return;
    }
    if (loggedInUser?.currentUser?.userType !== "jobSeeker") {
      toast.info("Only for jobSeekers");
      return;
    }
    navigate(`/${loggedInUser?.currentUser?._id}/createCV`);
  };

  const handleBenefit = () => {
    if (loggedInUser?.currentUser === null) {
      toast.error("Kindly login to continue");
      navigate("/signin");
      return;
    }
    if (loggedInUser?.currentUser?.userType !== "jobSeeker") {
      toast.info("Only for jobSeekers");
      return;
    }
    navigate(`/benefit`);
  };


      useEffect(() => {
    const fetchRecentJobs = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}job/recent`);
        const data = await res.json();
        
        if (data.success) {
          setJobs(data.jobs);
        }
      } catch (err) {
        console.error("Failed to fetch recent jobs", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentJobs();
  }, []);
  return (
    <div>
      <section
        style={{
          background: `url(${Background}) no-repeat center center/cover`,
        }}
        className="text-sm pt-16 sm:pt-20"
      >
        <div className="mb-10">
          <Header lightMode={true} />
        </div>

        <div className="absolute top-15 right-10 flex gap-4 mb-4 sm:mb-20">
          <button
            onClick={handleBenefit}
            className="bg-orange-500 px-6 py-2 rounded-full text-white hover:bg-orange-600 transition-colors"
          >
            Apply for allowance
          </button>
          <button
            onClick={handleCv}
            className="bg-orange-500 px-6 py-2 rounded-full text-white hover:bg-orange-600 transition-colors"
          >
            Create a free CV
          </button>
        </div>

        {/* search section */}
        <SearchBox />
      </section>
    </div>
  );
};

export default Hero;
